export default "__VITE_ASSET__c1db524b__"